import Tabs from "@mui/material/Tabs";
import { withStyles } from "tss-react/mui";

const CustomTabs = withStyles(Tabs, {
  root: {
    "& .MuiTabScrollButton-root.Mui-disabled": {
      width: "0px",
    },
    "& .MuiTabScrollButton-root": {
      width: "40px",
      transition: "width 0.1s",
    },
  },
});

export default CustomTabs;
